import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import HeroBanner from '../components/hero-banner'
import Project from '../components/project'

const AboutMe = class extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet        
          title="A little something about me"
          meta={[
            {
              name: 'description',
              content: `I'm a freelance web designer and fullstack web developer based in beautiful Norfolk`,
            },
          ]} />
        <HeroBanner heroId="blue-hero" nextId="introduction">
          <div className="heading">
            <h2>About me</h2>
            <h3>A little something about me</h3>
          </div>
        </HeroBanner>
        <div id="introduction" className="section white">
          <div className="wrapper">
            <div className="story-block story">
              <h1>Welcome, I'm Neil</h1>
              <p>
                I have over two decades of full stack web development experience
                starting in 1998 as a web developer for a small but successful
                organisation delivering educational learning resources. I then
                moved and worked for a highly successful uk online reseller
                before going freelance in 2009 where I now work out of my own
                small office in beautiful Norfolk, UK.
              </p>
              <p>
                Since going freelance I have had the pleasure and delight to
                work on many client websites in many industries from hospitality
                and catering to manufacturing, reselling and education to name
                but a few.
              </p>
              <p>
                I have a wide range of skills and development experience but my
                core skills and focus has been with the Microsoft web
                architecture of ASP.NET where I have over 20 years of experience
                although more recently I have expanded my skills to include the
                newer emerging frameworks such as React, Angular and the MEAN
                stack.
              </p>
            </div>
          </div>
        </div>
        <div className="section stiffkey">
          <div className="wrapper __cols">
            <div className="web-developer">
              <div className="story">
                <h2>Web Development</h2>
                <p>
                  As with all things technology based the world of the web
                  developer moves pretty quickly so keeping my skills fresh, up
                  to date and in trend is always a challenge, and a challenge
                  that I enjoy. My current skills include many front-end,
                  back-end and middleware languages that provides me the
                  necessary skills to work as a full stack developer.
                </p>
                <p>
                  As a full stack web developer I can call upon over 20 years of
                  experience and I am highly proficient in client-side
                  development using the latest HTML 5, CSS and JavaScript to
                  build fully dynamic responsive websites.
                </p>
                <p>
                  I have over two decades of experience in the Microsoft web
                  technologies being an early adopter of ASP.NET and moving with
                  their development and build to now working with ASP.NET Core
                  and ASP.NET 4 MVC although more recently I broadened my skills
                  to include the MEAN stack allowing me to offer sites and
                  single page applications built with NodeJs, ExpressJs, Angular
                  and MongoDb.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="section wevet white">
          <div className="wrapper">
            <div className="web-designer">
              <div className="story">
                <h2>Web Design</h2>
                <p>
                  As with web development my role as a web designer is also fast
                  moving, keeping up with the latest in design trends as well as
                  researching and exploring the latest in front-end development
                  to deliver clean fully responsive websites.
                </p>
                <p>
                  I have over two decades of experience in using Adobe Photoshop
                  to help with design as well as allowing me to easily
                  interogate the design in order to create pixel perfect
                  websites although more recently I have switched to Adobe
                  Illustrator and Adobe XD which has streamlined the design
                  process, providing cleaner design elements and allowing for
                  easier design manipulation especially for modern responsive
                  websites.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="section grid white">
          <div className="wrapper __cols">
            <h2 className="heading" data-tag="featured">
              <span>Featured project</span>
            </h2>
          </div>
          {data.allMarkdownRemark.edges.map(({ node }, index) => (
            <Project key={index} data={node} />
          ))}
          <div className="section center">
            <Link to="work" className="strong">
              View more work
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutMe

export const query = graphql`
  query aboutMeFeaturedWork {
    allMarkdownRemark(
      filter: {
        frontmatter: { layout: { eq: "Portfolio" }, featured: { eq: true } }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            overview
            website
            hero {
              publicURL
            }
            tags
            collaborators {
              service
              name
              website
            }
          }
          html
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about-me.js